import React from 'react';

const DashboardIcon = () => {
      return (
            <>
                  <span className="material-symbols-outlined">widgets</span>
            </>
      );
};

export default DashboardIcon;
